export var _menuTitleTheme = {
  baseStyle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingX: 's',
    paddingTop: {
      xs: 'none',
      s: 'xs'
    },
    height: '40px'
  }
};
//# sourceMappingURL=_MenuTitle.theme.js.map